module.exports = __webpack_public_path__ + "static/pie_chart_1-4f437a7ef6faa461f08546bb345287b0.png";